import BigNumber from 'bignumber.js'
import glitchABI from 'config/abi/glitch.json'
import multicall from 'utils/multicall'
import { getGlitchAddress } from 'utils/addressHelpers'

export const fetchUserGLITCH = async (account: string, includeTokenIds = true) => {
  const glitchAddress = getGlitchAddress()

  // Query total supply first to avoid revert errors
  const callTotalSupply = {
    address: glitchAddress,
    name: 'totalSupply',
  }

  const callUserMinted = {
    address: glitchAddress,
    name: 'userMinted',
    params: [account]
  }

  const callBalance = {
    address: glitchAddress,
    name: 'balanceOf',
    params: [account]
  }

  const calls = [callTotalSupply, callUserMinted, callBalance]
  const rawData = await multicall<BigNumber[]>(glitchABI, calls)
  const totalSupply = new BigNumber(rawData[0]).toNumber()
  const parsedAmounts = rawData.slice(1).map((glitchBalance) => new BigNumber(glitchBalance).toJSON())

  const result = {
    numMinted: parsedAmounts[0],
    balance: parsedAmounts[1],
    balanceTokenIds: []
  }

  // Fetch token IDs only if requested
  if (includeTokenIds) {
    const tokenCalls = []
    for (let i = 1; i <= totalSupply; i++) {
      tokenCalls.push({
        address: glitchAddress,
        name: 'ownerOf',
        params: [i]
      })
    }

    try {
      const rawOwners = await multicall<string[]>(glitchABI, tokenCalls)
      result.balanceTokenIds = rawOwners
        .map((ownerArray, index) => (ownerArray[0] === account ? index + 1 : null))
        .filter(id => id !== null);
    } catch (error) {
      console.error("Error fetching token ownership:", error)
    }
  }

  return result
}